import "./App.css";
import ProductsPage from "./components/ProductsPage";
export default function App() {
  
  return (
    <div className="App">
      <ProductsPage/>
    </div>
  );
}
